<template>
  <div class="general">
    <div class="heading">
      {{$ml.get('Action')}}
    </div>
    <div class="middle">
      <app-btn @click="block" v-if="activeUser.globalRole == 'user'">
        {{$ml.get('Pause')}}
      </app-btn>
      <app-btn @click="unBlock" v-else>
        {{$ml.get('Resume')}}
      </app-btn>
      <app-btn @click="deleteSub" styling="outline">
        {{$ml.get('Delete this account')}}
      </app-btn>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      activeUser: 'subAccount/activeUser',
    })
  },
  methods: {
    block () {
      API.subAccounts.blockUser(this.activeUser.id).then(res => {
        this.activeUser.globalRole = 'blocked';
        this.$notify({group: 'notices', title: this.$ml.get('User successfully blocked!'), type: 'success'});
      });
    },
    unBlock () {
      API.subAccounts.unBlockUser(this.activeUser.id).then(res => {
        this.activeUser.globalRole = 'user';
        this.$notify({group: 'notices', title: this.$ml.get('User unblocked successfully!'), type: 'success'});
      });
    },
    deleteSub () {
      API.subAccounts.deleteUser(this.activeUser.id).then(res => {
        this.$notify({group: 'notices', title: this.$ml.get('User successfully deleted!'), type: 'success'});
        this.$store.dispatch('subAccount/getUsers');
        this.$router.push('/dashboard/sub-accounts/');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.general {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 640px) {
    align-items: center;
  }

  .heading {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    color: #4C5056;
    margin-bottom: 15px;
    padding-left: 20px;
  }

  .middle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;

    >button {
      margin: 22px 20px;
      width: calc(50% - 40px);
      min-width: 250px;
    }
  }
}
</style>
